export const addProduct = product => {
  return {
    type: 'PRODUCT_ADDED',
    product
  }
}

export const updateProduct = product => {
  return {
    type: 'PRODUCT_UPDATED',
    product
  }
}

export const removeProduct = productId => {
  return {
    type: 'PRODUCT_REMOVED',
    productId
  }
}

export const buyProduct = productId => {
  return {
    type: 'PRODUCT_BOUGHT',
    productId
  }
}